import { render, staticRenderFns } from "./ProcurementPurchaseOrder.vue?vue&type=template&id=74ed15f5"
import script from "./ProcurementPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./ProcurementPurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports